module.exports = __webpack_public_path__ + "static/media/notes-of-love-six.67a7aec5.png";